import { createApi } from '@reduxjs/toolkit/query/react'
import { generateRPCQuery, getBaseQuery } from './apiUtils'
import apiConstants from './constants'

export const achievementsApi = createApi({
  reducerPath: 'achievementsApi',
  refetchOnFocus: false,
  tagTypes: ['AchievementLogs'],
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    getAchievementsLogs: builder.query({
      query: (requestParams: GetAchievementsLogsParam) =>
        generateRPCQuery(
          apiConstants.ACHIEVEMENTS_RPC_PATH,
          'getAchievementsLog',
          requestParams
        ),
      providesTags: ['AchievementLogs']
    }),
    getAchievementInfoByID: builder.query({
      query: (requestParams: GetAchievementDetailsParams) =>
        generateRPCQuery(
          apiConstants.ACHIEVEMENTS_RPC_PATH,
          'getAchievementLogInfoByID',
          requestParams
        )
    }),
    processAchievements: builder.query({
      query: (requestParams: ProcessAchievementsParams) =>
        generateRPCQuery(
          apiConstants.ACHIEVEMENTS_RPC_PATH,
          'processAchievements',
          requestParams
        )
    }),
    reportAchievements: builder.mutation({
      query: (requestParams: ReportAchievementsParams) =>
        generateRPCQuery(
          apiConstants.ACHIEVEMENTS_RPC_PATH,
          'reportAchievements',
          requestParams
        ),
      invalidatesTags: ['AchievementLogs']
    })
  })
})

export const {
  useGetAchievementInfoByIDQuery,
  useGetAchievementsLogsQuery,
  useLazyProcessAchievementsQuery,
  useReportAchievementsMutation
} = achievementsApi
